/** @format */

const template = `
<sis-typeahead
  [highlight-search-term]="true"
  [input-formatter]="$ctrl.getVisibleTitle"
  [model]="$ctrl.employee"
  (model-change)="$ctrl.selectItem($event)"
  [placeholder]="'SIS_COMPONENTS.PERSON.SEARCH_EMPLOYEE.SEARCH_EMPLOYEES' | translate"
  [required]="$ctrl.required"
  [disabled]="$ctrl.disable"
  [result-formatter]="$ctrl.getVisibleTitle"
  (select-item)="$event.item.disabled ? $event.preventDefault() : $ctrl.selectItem($event.item)"
  [typeahead]="$ctrl.doSearch"
  data-cy="search-employee-typeahead"></sis-typeahead>
`;
export default template;
